import PropTypes from 'prop-types';
import React from 'react';
import {ic_clear as icClear} from 'react-icons-kit/md/ic_clear';
import IconButton from '@sinclair-digital/sbg-storyline-components/src/components/IconButton';
import {StyledTag} from './styled/StyledTag';
import {StyledTagBody} from './styled/StyledTagBody';
import {StyledTagName} from './styled/StyledTagName';
import {StyledDimensionName} from './styled/StyledDimensionName';
import {StyleVerticalBar} from './styled/StyleVerticalBar';
import {StyledRelevance} from './styled/StyledRelevance';
import {StyleButton} from './styled/StyleButton';

/**
 * Tag component
 *
 * @param {Object} props
 * @property {'producer'|'seo'|'hidden'|'ai-assist'} props.type
 * @property {string} props.name
 * @property {string} props.dimension
 * @property {string} props.uuid
 * @property {number} props.relevance
 * @property {boolean} props.included
 * @property {boolean} props.removable
 * @property {boolean} props.userGenerated
 * @property {number} props.position
 * @property {{dimension: boolean, relevance: boolean}|boolean} showFeatures
 * @returns {Element}
 * @constructor
 */
function Tag(props) {
    return (
        <StyledTag
            className={props.type}
            data-uuid={props.uuid}
        >
            <StyledTagBody title={`${props.dimension}`}>
                <StyledTagName>{props.name}</StyledTagName>
                <StyledDimensionName className={props.type}>{props.dimension}</StyledDimensionName>
            </StyledTagBody>
            <StyleVerticalBar />
            <StyledRelevance>
                <StyleButton
                    onPointerDown={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                    }}
                >
                    <IconButton
                        disabled={props.removable === false || !props.isEditable}
                        className={'icon-button'}
                        size={25}
                        theme={'transparent'}
                        icon={
                            props.included
                                ? icClear
                                : {
                                    viewBox: '0 0 24 24',
                                    children: [{
                                        'name': 'path',
                                        'attribs': {
                                            'd': '',
                                        },
                                    }],
                                }
                        }
                        onClick={(event) => {
                            props.onClick(event);
                        }}
                    />
                </StyleButton>
            </StyledRelevance>
        </StyledTag>
    );
}
Tag.propTypes = {
    isEditable: PropTypes.bool,
    type: PropTypes.oneOf(['regular', 'hidden']),
    name: PropTypes.string,
    dimension: PropTypes.string,
    uuid: PropTypes.string,
    relevance: PropTypes.number,
    included: PropTypes.bool,
    removable: PropTypes.bool,
    onClick: PropTypes.func,
    userGenerated: PropTypes.bool,
    position: PropTypes.number,
    showFeatures: PropTypes.oneOfType([
        PropTypes.shape({
            relevance: PropTypes.bool,
            dimension: PropTypes.bool,
        }),
        PropTypes.bool,
    ]),
};
Tag.defaultProps = {
    onClick: () => {
        // eslint-disable-next-line no-console
        console.log('button clicked');
    },
    showFeatures: false,
    isEditable: false,
};

export default Tag;